export default "__VITE_ASSET__Dd$odH9e__"